import { useParams } from 'react-router-dom';
import { ProblemCollection } from '@/components/problems/ProblemCollection';
import { topicFromParam, topicPath } from '@/data/topics';
import { TOPICS_INDEX_PATH, topicStructuredData } from '@/lib/structuredData';
import { NotFound } from './NotFound';

/** Mavzu sahifasi: /topics/join */
export function Topic() {
  const topic = topicFromParam(useParams().topic);
  if (!topic) return <NotFound />;
  return (
    <ProblemCollection
      key={topic.slug}
      path={topicPath(topic.slug)}
      title={topic.title}
      desc={topic.desc}
      icon={topic.icon}
      seoName={`${topic.title.uz} — SQL masalalar`}
      query={{ topic: topic.slug }}
      parent={{ to: TOPICS_INDEX_PATH, labelKey: 'nav.topics' }}
      jsonLd={topicStructuredData(topic)}
      learnTopic={topic.slug}
    />
  );
}
